// extracted by mini-css-extract-plugin
export default {"container":"container_container__5Kg7A","title":"container_title__lhF4U","red":"container_red__cgzKN","white":"container_white__BwSMb"};